import styled, { css } from 'styled-components';
import { key, palette } from 'styled-theme';
import { media } from '../../../helper/styleHelper';

const fontSettings = {
  normal: {
    size: key('sizes.font.normal', '11px'),
    spacing: '0.32px',
  },
};

const xlFontSettings = {
  normal: {
    size: key('sizes.xlFont.normal', '14px'),
    spacing: '0.32px',
  },
};

const xlrFontSettings = {
  normal: {
    size: key('sizes.xlrFont.normal', '14px'),
    spacing: '0.32px',
  },
};

const xxlFontSettings = {
  normal: {
    size: key('sizes.xxlFont.normal', '16px'),
    spacing: '0.32px',
  },
};

const sizes = {
  normal: {
    width: key('sizes.button.normal.width', '175px'),
    height: key('sizes.button.normal.height', '30px'),
    borderBottom: '0px',
    borderRadius: key('sizes.borderRadius.normal', '18px'),
  },
};

const xlSizes = {
  normal: {
    width: key('sizes.button.normal.width', '150px'),
    height: key('sizes.button.normal.height', '30px'),
    borderBottom: '0px',
    borderRadius: key('sizes.borderRadius.normal', '18px'),
  },
};

const xlrSizes = {
  normal: {
    width: key('sizes.button.normal.width', '150px'),
    height: key('sizes.button.normal.height', '30px'),
    borderBottom: '0px',
    borderRadius: key('sizes.borderRadius.normal', '18px'),
  },
};

const xxlSizes = {
  normal: {
    width: key('sizes.button.normal.width', '150px'),
    height: key('sizes.button.normal.height', '30px'),
    borderBottom: '0px',
    borderRadius: key('sizes.borderRadius.normal', '18px'),
  },
};

export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-width: 0.5px;
  transition: opacity 0.3s;
  text-transform: uppercase;
  font-family: ${key('fonts.primary', 'JetBrains Mono Regular')};
  border-style: solid;

  ${(props) => css`
    border-radius: ${props.round === 'true' ? sizes[props.sizevalue].borderRadius : '18px'};
    min-width: ${props.buttonMinWidth ? props.buttonMinWidth : sizes[props.sizevalue].width};
    max-width: fit-content;
    height: ${sizes[props.sizevalue].height};
    font-size: ${fontSettings[props.sizevalue].size};
    font-weight: ${props.weight};
    letter-spacing: ${fontSettings[props.sizevalue].spacing};
  `}

  ${(props) => media.xl`
    border-radius: ${props.round === 'true' ? xlSizes[props.sizevalue].borderRadius : '18px'};
    height: ${xlSizes[props.sizevalue].height};
    font-size: ${xlFontSettings[props.sizevalue].size};
    letter-spacing: ${xlFontSettings[props.sizevalue].spacing};
  `}

  ${(props) => media.xlr`
    border-radius: ${props.round === 'true' ? xlrSizes[props.sizevalue].borderRadius : '18px'};
    height: ${xlrSizes[props.sizevalue].height};
    font-size: ${xlrFontSettings[props.sizevalue].size};
    letter-spacing: ${xlrFontSettings[props.sizevalue].spacing};
  `}

  ${(props) => media.xxl`
    border-radius: ${props.round === 'true' ? xxlSizes[props.sizevalue].borderRadius : '18px'};
    height: ${xxlSizes[props.sizevalue].height};
    font-size: ${xxlFontSettings[props.sizevalue].size};
    letter-spacing: ${xxlFontSettings[props.sizevalue].spacing};
  `}
  width: 100%;

  ${(props) =>
    props.varient === 'gradient'
      ? css`
          background: linear-gradient(90deg, #7b5cff, #60a5fa);
          color: white;
          border: none;
        `
      : props.varient === 'outline'
        ? css`
            border: 1.5px solid var(--1, #7b5cff);
            color: black;
            background-color: transparent;
          `
        : css``}

  &.focused,
  &:hover {
    &,
    &:focus,
    &:active {
      cursor: pointer;
    }
  }

  ${({ disabled }) =>
    disabled
      ? css`
          color: black;
          cursor: not-allowed !important;
          background: ${palette('gray', 0)} !important;
          border: none !important;
        `
      : css``}
`;

export const Spinner = styled.div`
  width: 1.25rem;
  height: 1.25rem;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 3px solid #fff;
  animation: spin 1s linear infinite;
  margin-right: 10px;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
